export const stringifyNumericDisplayOptions = (value) => {
    if (Array.isArray(value)) {
        return value.map(stringifyNumericDisplayOptions);
    }

    if (value && typeof value === 'object') {
        return Object.entries(value).reduce((normalized, [key, optionValue]) => {
            normalized[key] = stringifyNumericDisplayOptions(optionValue);
            return normalized;
        }, {});
    }

    return typeof value === 'number' ? String(value) : value;
};

export const isReservedHomeSection = (section) => {
    const title = (section?.title || '').toString().trim().toLowerCase().replace(/[\s_]+/g, '-');
    return ['book-again', 'category', 'categories', 'app-banner', 'quick-book'].includes(title);
};
